import React, { useEffect, useState } from 'react'
import {
    GrcTable,
    GrcTableBody,
    GrcTableCell,
    GrcTableContainer,
    GrcTableHead,
    GrcTableHeadRow,
    GrcTableRow
} from '../../Common/ui/TableComponent'
import EditPencilIcon from '../../Common/Icon/EditPencilIcon'
import { IconButton, Pagination, Card, Box, Tooltip, Chip, Grid } from '@mui/material'
import { Button } from '../../Common/ui/button'
import { IoAdd } from 'react-icons/io5'
import { TbArrowsSort } from 'react-icons/tb'
import CustomSearchField from '../../Common/ui/searchInput'
import AddBoardDrawer from '../../Components/Governance/AddBoardDrawer'
import EditBoardDrawer from '../../Components/Governance/EditBoardDrawer'
import { useBoardMemberStore } from './store/BoardMemberStore'
import Loading from '../../Common/ui/Loading'
import useCustomNavigate from '../../Common/ui/Navigate'
import * as RoutePaths from '../../Entities/RoutePath'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'
import { RxCrossCircled } from 'react-icons/rx'
import { BiCopy, BiSolidCopy } from 'react-icons/bi'
import { cn, featValid } from 'src/lib/utils'
import { CREATE_MANAGEMENT_TEAM, UPDATE_MANAGEMENT_TEAM } from 'src/Entities/Features'
import { AiOutlineCluster } from 'react-icons/ai'
import * as EndPoints from '../../Entities/EndPoints'
import Axios from 'src/Axios'

const BoardMembers = () => {
    const { getAllBoardMember, getAllBoardMemberDetailsLoading, getAllBoardMemberDetails, createBoardMember, createBoardMemberDataLoading } = useBoardMemberStore()
    const [ currentPage, setCurrentPage ] = useState(1)
    const [ regulationTableSearchValue, setRegulationTableSearchValue ] = useState('')
    const [ addState, setAddState ] = useState({ right: false })
    const [ newNode, setNewNode ] = useState({})
    const [ editState, setEditState ] = useState({ right: false })
    const [ editNode, setEditNode ] = useState({})
    const [ sortConfig, setSortConfig ] = useState({ key: null, direction: 'asc' })
    const [ isCopy, setIsCopy ] = useState({ phNumber: false, emailId: false })
    const [ expandedRow, setExpandedRow ] = useState(null)
    const [ selectDetails, setSelectDetails ] = useState(null)
    const rowsPerPage = 5
    const totalPages = Math.ceil(getAllBoardMemberDetails.length / rowsPerPage)
    const orgId = localStorage.getItem('orgId')
    const customNavigate = useCustomNavigate()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const [ loading, setLoading ] = useState(false)

    const onAdd = (AddNodeData, resetAll) => {
        setLoading(true)
        const createNodeRequest = [
            {
                firstName: AddNodeData?.firstName || '',
                middleName: AddNodeData?.middleName || '',
                lastName: AddNodeData?.lastName || '',
                emailId: AddNodeData?.emailId || '',
                // phoneNo: AddNodeData?.phoneNo || '',
                phoneNo: AddNodeData?.phoneNumber || '',
                phoneCode: AddNodeData?.phoneCode || '',
                phoneCountryCode: AddNodeData?.phoneCountryCode || '',
                isActive: false,
                orgId,
                userId: AddNodeData?.userId || 0,
                address: AddNodeData?.address || '',
                city: AddNodeData?.city || '',
                state: AddNodeData?.state || '',
                country: AddNodeData?.country || '',
                pincode: AddNodeData?.pincode || '',
                status: AddNodeData?.status || 1
            }
        ]

        const createBoardMemberFormData = new FormData()

        createNodeRequest.forEach((item, index) => {
            Object.entries(item).forEach(([ subKey, subValue ]) => {
                createBoardMemberFormData.append(`createUser[${index}][${subKey}]`, subValue)
            })
        })
        // setAddState({ right: false })
        createBoardMember(orgId, createBoardMemberFormData)
            .then((res) => {
                if (res.data) {
                    getAllBoardMember(orgId)
                    toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Management team member added successfully')}</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                    setAddState({ right: false })
                    setLoading(false)
                } else {
                    const warningMessage = res?.err?.response?.data?.errors
                    if (Array.isArray(warningMessage) && warningMessage.length > 0) {
                        warningMessage.forEach((message) => {
                            toast.warning(<p>{message}</p>, { position: 'top-right', theme: 'light' })
                        })
                    } else {
                        toast.warning(<p>{warningMessage || 'Unable to create details'}</p>, { position: 'top-right', theme: 'light' })
                    }
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.warn(err)
                toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>{t('Error in adding management team try again!')}</p></p>, {
                    position: 'top-right', hideProgressBar: true, theme: 'light'
                })
                getAllBoardMember(orgId)
                setLoading(false)
            })
    }

    const onEdit = (EditNodeData) => {
        setLoading(true)
        const updateNodeRequest = [
            {
                firstName: EditNodeData?.firstName || '',
                middleName: EditNodeData?.middleName ? EditNodeData?.middleName : '',
                lastName: EditNodeData?.lastName || '',
                emailId: EditNodeData?.emailId || '',
                // phoneNo: EditNodeData?.phoneNo || '',
                phoneNo: EditNodeData?.phoneNumber || '',
                phoneCode: EditNodeData?.phoneCode || '',
                phoneCountryCode: EditNodeData?.phoneCountryCode || '',
                isActive: !!EditNodeData?.isActive,
                orgId: EditNodeData?.organizationId || orgId,
                userId: EditNodeData?.userId,
                address: EditNodeData?.address || '',
                city: EditNodeData?.city || '',
                state: EditNodeData?.state || '',
                country: EditNodeData?.country || '',
                pincode: EditNodeData?.pincode || '',
                status: EditNodeData?.status || 1
            }
        ]

        const updateBoardMemberFormData = new FormData()

        updateNodeRequest.forEach((item, index) => {
            Object.entries(item).forEach(([ subKey, subValue ]) => {
                updateBoardMemberFormData.append(`createUser[${index}][${subKey}]`, subValue)
            })
        })
        // setEditState({ right: false })
        createBoardMember(orgId, updateBoardMemberFormData)
            .then((res) => {
                if (res.data) {
                    getAllBoardMember(orgId)
                    toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Management Team details updated successfully')}</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                    setEditState({ right: false })
                    setLoading(false)
                    setExpandedRow(editNode)
                } else {
                    const warningMessage = res?.err?.response?.data?.errors
                    if (Array.isArray(warningMessage) && warningMessage.length > 0) {
                        warningMessage.forEach((message) => {
                            toast.warning(<p>{message}</p>, { position: 'top-right', theme: 'light' })
                        })
                    } else {
                        toast.warning(<p>{warningMessage || 'Unable to update details'}</p>, { position: 'top-right', theme: 'light' })
                    }
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.warn(err)
                toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>{t('Error in updating management team details try again!')}</p></p>, {
                    position: 'top-right', hideProgressBar: true, theme: 'light'
                })
                getAllBoardMember(orgId)
                setLoading(false)
            })
    }

    useEffect(() => {
        getAllBoardMember(orgId)
    }, [])

    useEffect(() => {
        if (location.pathname.includes('management-structure-profile') && location?.state?.memberProfileDetail) {
            setExpandedRow(location?.state?.memberProfileDetail)
            setSelectDetails(true)
        } else {
            setSelectDetails(false)
            setExpandedRow({ ...isCopy, phNumber: false, emailId: false })
            setIsCopy({})
        }
    }, [location?.state?.memberProfileDetail])

    useEffect(() => {
        setExpandedRow(null)
        setSelectDetails(false)
        setIsCopy({ ...isCopy, phNumber: false, emailId: false })
        navigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.GOVERNANCE.MANAGEMENT_STRUCTURE)
    }, [regulationTableSearchValue])

    const sortedData = [...getAllBoardMemberDetails?.map((mapDt, mapIdx) => {
        return { ...mapDt, rowId: mapIdx + 1 }
    })].sort((a, b) => {
        if (sortConfig.key) {
            const direction = sortConfig.direction === 'asc' ? 1 : -1
            if (a[sortConfig.key] < b[sortConfig.key]) return -1 * direction
            if (a[sortConfig.key] > b[sortConfig.key]) return 1 * direction
            return 0
        }
        return 0
    })

    const filteredBoardMembers = sortedData.filter((row) => {
        const searchValue = regulationTableSearchValue.toLowerCase()

        return Object.entries(row).some(([ key, value ]) => {
            if (value !== null && value !== undefined) {
                if ([ 'firstName', 'middleName', 'lastName', 'emailId', 'phoneNo' ].includes(key)) {
                    return value.toString().toLowerCase().includes(searchValue)
                }
            }
            return false
        })
    })

    const paginatedData = filteredBoardMembers.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    )

    const handlePageChange = (event, value) => {
        setCurrentPage(value)
    }

    const handleAddClick = (item) => {
        setNewNode(item)
        setAddState({ right: true })
    }

    const handleEditClick = (item) => {
        setEditNode({ ...item, phoneNumber: item?.phoneNo })
        setEditState({ right: true })
        setSelectDetails(false)
    }

    const handleSort = (key) => {
        let direction = 'asc'
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc'
        }
        setSortConfig({ key, direction })
    }

    const handleNameClick = (item) => {
        setIsCopy({ ...isCopy, phNumber: false, emailId: false })
        navigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.GOVERNANCE.MANAGEMENT_STRUCTURE + RoutePaths.GOVERNANCE.MANAGEMENT_STRUCTURE_PROFILE, { state: { memberProfileDetail: item } })
    }

    const profileDataExportToCSV = () => {
        const data = [
            {
                S_No: 1,
                Full_Name: `${expandedRow?.firstName} ${expandedRow?.lastName}`,
                Email_ID: expandedRow?.emailId || '',
                Phone_Number: expandedRow?.phoneNo || '',
                Address: `${expandedRow?.address}, ${expandedRow?.city}, ${expandedRow?.state}, ${expandedRow?.pincode}.`
            }
        ]

        const ws = XLSX.utils.json_to_sheet(data)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

        XLSX.writeFile(wb, `${expandedRow?.firstName} ${expandedRow?.lastName} ProfileDetails.csv`)
    }

    const allBoardMembersDataExportToCSV = () => {
        const data = paginatedData?.map((mapData, index) => {
            return { S_No: index + 1, Full_Name: `${mapData?.firstName} ${mapData?.lastName}`, Email_ID: mapData?.emailId, Phone_Number: mapData?.phoneNo }
        })

        const ws = XLSX.utils.json_to_sheet(data)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

        XLSX.writeFile(wb, 'ManagementDetails.csv')
    }
    const handleCloseClick = () => {
        setExpandedRow(null)
        setSelectDetails(false)
        navigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.GOVERNANCE.MANAGEMENT_STRUCTURE)
    }
    const features = JSON.parse(localStorage.getItem('features'))
    const handleCopy = (text, field) => {
        navigator.clipboard.writeText(text).then(() => {
            setIsCopy({ ...isCopy, [field]: true })
            toast(
                <div className="flex flex-row justify-evenly items-center">
                    <BiSolidCopy color="hsl(var(--primary))" />
                    <p>{t(`${field} is Copied to clipboard`)}</p>
                </div>,
                {
                    position: 'top-right',
                    hideProgressBar: true,
                    theme: 'light'
                }
            )
        })
    }

    const instance = Axios.getInstance()

    // Add these state variables at the top of your component
    const [ countryName, setCountryName ] = useState('')
    const [ stateName, setStateName ] = useState('')
    const [ cityName, setCityName ] = useState('')

    // Add these useEffect hooks to fetch names when expandedRow changes
    useEffect(() => {
        const fetchCountryName = async () => {
            if (expandedRow?.country) {
                try {
                    const response = await instance.get(
                    `${EndPoints.API_ENDPOINT}/masterController/countries?id=${expandedRow.country}`
                    )
                    const country = response?.data?.find(country => country.id === expandedRow.country)
                    setCountryName(country.name || '')
                } catch (error) {
                    console.error('Error fetching country:', error)
                }
            }
        }

        fetchCountryName()
    }, [expandedRow?.country])

    useEffect(() => {
        const fetchStateName = async () => {
            if (expandedRow?.state) {
                try {
                    const response = await instance.get(
                    `${EndPoints.API_ENDPOINT}/masterController/states?id=${expandedRow.country}`
                    )
                    const state = response?.data?.find(state => state.id === expandedRow.state)
                    setStateName(state.name || '')
                } catch (error) {
                    console.error('Error fetching state:', error)
                }
            }
        }

        fetchStateName()
    }, [expandedRow?.state])

    useEffect(() => {
        const fetchCityName = async () => {
            if (expandedRow?.city) {
                try {
                    const response = await instance.get(
                    `${EndPoints.API_ENDPOINT}/masterController/cities?id=${expandedRow.state}`
                    )
                    const city = response?.data?.find(city => city.id === expandedRow.city)
                    setCityName(city.name || '')
                } catch (error) {
                    console.error('Error fetching city:', error)
                }
            }
        }

        fetchCityName()
    }, [expandedRow?.city])

    return (
        <div className="flex h-[100%] p-4">
            {getAllBoardMemberDetailsLoading
                ? (
                    <Loading isLoading={createBoardMemberDataLoading} />
                )
                : (<><div className="h-[100%] w-[100%]">
                    <Card className="flex flex-col gap-4 h-[100%] p-5">
                        <div className="flex my-2">
                            <div>
                                <CustomSearchField
                                    value={regulationTableSearchValue}
                                    setSearch={setRegulationTableSearchValue}
                                    onValueChange={(e) => setRegulationTableSearchValue(e)}
                                />
                            </div>
                            <div className="ml-auto flex items-center space-x-5 mr-2">
                                <Tooltip title="Download Member Details" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <Button variant="outline" className="grc-btn-one flex items-center justify-center !p-[6px] !border-2 !border-[#b2d9d8]">
                                        <img src={'/Common/Icon/Download.svg'} className="w-6 h-6" onClick={() => { allBoardMembersDataExportToCSV() } } />
                                    </Button>
                                </Tooltip>
                                <Tooltip title="View Org Chart" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <Button variant="outline" className="grc-btn-one flex items-center justify-center !p-[6px] !border-2 !border-[#b2d9d8]" onClick={() => customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.GOVERNANCE.ORG_CHART)}>
                                        {/* <img src={'/Common/Icon/NetworkTree.svg'} className="w-6 h-6" /> */}
                                        <AiOutlineCluster size={24} />
                                    </Button>
                                </Tooltip>
                                {featValid(features, CREATE_MANAGEMENT_TEAM) && (
                                    <Tooltip title="Add Member" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                        <Button variant="outline" className="grc-btn-one flex items-center justify-center !p-[6px] !border-2 !border-[#b2d9d8]" onClick={() => handleAddClick()}>
                                            <IoAdd className="w-6 h-6" />
                                        </Button>
                                    </Tooltip>
                                )}
                            </div>
                        </div>
                        <div className="flex w-[100%] h-[90%] overflow-auto">
                            <div className='flex flex-col w-[100%] h-[100%] '>
                                <GrcTableContainer sx={{ flex: '1' }} className={`${expandedRow ? 'w-[50%]' : 'w-[100%]'} flex flex-col overflow-auto ${expandedRow ? 'table-header-row-one' : ''}`}>
                                    <GrcTable>
                                        <GrcTableHead sx={{ position: 'sticky', top: 0, zIndex: 2 }}>
                                            <GrcTableHeadRow>
                                                <GrcTableCell sx={{ minWidth: '40px', pl: 3.5 }}><Tooltip title="S.No" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>#</Tooltip></GrcTableCell>
                                                <GrcTableCell sx={{ minWidth: '200px' }}>
                                                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, fontWeight: 500 }}>
                                                        {t('Name')}
                                                        <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}> <TbArrowsSort cursor="pointer" onClick={() => handleSort('firstName')} /></Tooltip>
                                                    </Box>
                                                </GrcTableCell>
                                                <GrcTableCell sx={{ minWidth: '300px' }}>
                                                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, fontWeight: 500 }}>
                                                        {t('Email ID')}
                                                        <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}> <TbArrowsSort cursor="pointer" onClick={() => handleSort('emailId')} /></Tooltip>
                                                    </Box>
                                                </GrcTableCell>
                                                {selectDetails === false && (
                                                    <>
                                                        <GrcTableCell sx={{ minWidth: '300px' }}>
                                                            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, fontWeight: 500 }}>
                                                                {t('Phone Number')}
                                                                <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}> <TbArrowsSort cursor="pointer" onClick={() => handleSort('phoneNo')} /></Tooltip>
                                                            </Box>
                                                        </GrcTableCell>
                                                        <GrcTableCell sx={{ minWidth: '40px', right: 0 }} />
                                                    </>
                                                )}
                                            </GrcTableHeadRow>
                                        </GrcTableHead>
                                        <GrcTableBody sx={{ overflow: 'auto' }}>
                                            {createBoardMemberDataLoading || getAllBoardMemberDetailsLoading
                                                ? (
                                                    <GrcTableRow>
                                                        <GrcTableCell colSpan={5} className="text-center">
                                                            <p className="text-muted text-center">Loading...</p>
                                                        </GrcTableCell>
                                                    </GrcTableRow>
                                                )
                                                : paginatedData?.length === 0
                                                    ? (
                                                        <GrcTableRow>
                                                            <GrcTableCell colSpan={5} className="text-center">
                                                                <p className="text-muted text-center">{t('No Data Found')}</p>
                                                            </GrcTableCell>
                                                        </GrcTableRow>
                                                    )
                                                    : (
                                                        paginatedData?.map((item, index) => {
                                                            item.sNo = (currentPage - 1) * rowsPerPage + index + 1
                                                            return (
                                                                <React.Fragment key={index}>
                                                                    <GrcTableRow>
                                                                        <GrcTableCell className="min-w-40px left-0 flex justify-center items-center h-full">
                                                                            <div style={{ backgroundColor: 'hsl(var(--primary-foreground))', borderRadius: '50%', width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'hsl(var(--primary))' }}>
                                                                                {item?.sNo}
                                                                            </div>
                                                                        </GrcTableCell>
                                                                        <GrcTableCell sx={{ minWidth: '200px', maxWidth: '400px', cursor: 'pointer', left: 42 }} onClick={() => handleNameClick(item)}>
                                                                            {`${item.firstName}${' '}${item.middleName || ''}${' '}${item.lastName}`}
                                                                        </GrcTableCell>
                                                                        <GrcTableCell sx={{ minWidth: '300px', maxWidth: '300px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                            {item.emailId}
                                                                        </GrcTableCell>
                                                                        {selectDetails === false && (
                                                                            <>
                                                                                <GrcTableCell sx={{ minWidth: '300px', maxWidth: '300px' }}>
                                                                                    <p className='text-left'> {item.phoneCode ? item.phoneCode : '' }{item.phoneNo ? item.phoneNo : '-'}</p>
                                                                                </GrcTableCell>
                                                                                <GrcTableCell sx={{ minWidth: '40px', maxWidth: '60px', right: 0 }}>
                                                                                    {featValid(features, UPDATE_MANAGEMENT_TEAM) &&
                                                                                <Tooltip title="Edit Member" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                                                    <IconButton onClick={() => handleEditClick(item)} sx={{ padding: 0.3 }}>
                                                                                        <EditPencilIcon />
                                                                                    </IconButton>
                                                                                </Tooltip>}
                                                                                </GrcTableCell>
                                                                            </>
                                                                        )}
                                                                    </GrcTableRow>
                                                                </React.Fragment>
                                                            )
                                                        })
                                                    )}
                                        </GrcTableBody>
                                    </GrcTable>
                                </GrcTableContainer>
                                {expandedRow && paginatedData.length > 0 && <div className={cn('border-t-2 border-t-primary-foreground flex flex-row items-center justify-between py-2 pr-[20px] w-[100%]')}>
                                    <p className="text-muted text-xl">
                                        {t('Showing data')} {(currentPage - 1) * rowsPerPage + 1} {t('to')} {Math.min(currentPage * rowsPerPage, filteredBoardMembers?.length)} {t('of')} {filteredBoardMembers?.length} {t('entries')}
                                    </p>
                                    <Pagination
                                        count={totalPages}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="primary"
                                        shape="rounded"
                                        variant="outlined"
                                    />
                                </div>}
                            </div>
                            { selectDetails && (
                                <GrcTableContainer className={`w-[50%] border-l-2 border-primary-foreground ${expandedRow ? 'table-header-row-two' : ''}`}>
                                    <GrcTable>
                                        <GrcTableHead>
                                            <GrcTableHeadRow>
                                                <GrcTableCell>
                                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, alignItems: 'center', padding: 0 }}>
                                                        <Tooltip title="Download Member Detail" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                            <IconButton> <img src={'/Common/Icon/Download.svg'} style={{ cursor: 'pointer', width: '25px', height: '25px' }} onClick={() => { profileDataExportToCSV() } } /></IconButton>
                                                        </Tooltip>
                                                        {featValid(features, UPDATE_MANAGEMENT_TEAM) &&
                                                        <Tooltip title="Edit Member" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                            <IconButton onClick={() => handleEditClick(expandedRow)}><EditPencilIcon /></IconButton>
                                                        </Tooltip>}
                                                        <Tooltip title="Close" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                            <IconButton onClick={handleCloseClick} style={{ cursor: 'pointer', color: 'hsl(var(--primary))' }}><RxCrossCircled size={25} /></IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                </GrcTableCell>
                                            </GrcTableHeadRow>
                                        </GrcTableHead>
                                        <div className='w-[100%] h-[50%] px-8 py-4'>
                                            <Grid container className='items-baseline justify-center'>
                                                <Grid item lg={7} md={12}>
                                                    <div className="flex flex-row items-center gap-4 h-full mb-10">
                                                        <div className="flex items-center min-w-0">
                                                            <div className="text-2xl font-semibold text-primary truncate"
                                                                style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                {`${expandedRow?.firstName || ''} ${expandedRow?.middleName || ''} ${expandedRow?.lastName || ''}`}
                                                            </div>
                                                        </div>
                                                        <div className="flex-shrink-0 ml-2">
                                                            <Chip label={expandedRow?.isActive ? 'Active' : 'In Active'}
                                                                style={{ backgroundColor: expandedRow?.isActive ? 'hsl(var(--primary))' : 'hsl(var(--Risk))', color: 'white', height: '20px', borderRadius: '10px', fontSize: '12px' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item lg={5} md={12}>
                                                    <div className="flex flex-row mb-10">
                                                        <p className="text-lg text-primary font-semibold">Effective Date</p>
                                                        <p className="ml-6 text-base text-muted">{expandedRow?.fromDate || '-'}</p>
                                                    </div>
                                                </Grid>
                                                <Grid item lg={7} md={12}>
                                                    <div className="flex flex-row py-2 items-baseline mb-4 mr-4">
                                                        <p className="text-lg text-primary font-semibold text-nowrap">Email ID</p>
                                                        <p
                                                            className={`ml-8 text-base break-all text-muted mr-4 ${expandedRow?.emailId?.length >= 10 ? 'text-wrap' : ''}`}
                                                        >
                                                            {expandedRow?.emailId || '-'}
                                                        </p>
                                                        {!isCopy?.emailId
                                                            ? (
                                                                <Tooltip title="Copy EmailID" placement="top"
                                                                    componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                                    <div><BiCopy color="hsl(var(--primary))" onClick={() => handleCopy(expandedRow?.emailId, 'Email Id')} className="cursor-pointer"/></div>
                                                                </Tooltip>
                                                            )
                                                            : (
                                                                <BiSolidCopy color="hsl(var(--primary))" onClick={() => handleCopy(expandedRow?.emailId, 'Email Id')} className="cursor-pointer"/>
                                                            )}
                                                    </div>
                                                </Grid>
                                                <Grid item lg={5} md={12}>
                                                    <div className="flex flex-row py-2 items-baseline mb-4">
                                                        <p className="text-lg text-primary font-semibold text-nowrap">Phone Number</p>
                                                        <p className="ml-8 mr-4 text-base break-words text-muted">{expandedRow?.phoneNo || '-'}</p>
                                                        {expandedRow?.phoneNo !== null && (
                                                            !isCopy?.phNumber
                                                                ? (
                                                                    <Tooltip title="Copy Phone Number" placement="top"
                                                                        componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                                        <div><BiCopy color="hsl(var(--primary))" onClick={() => handleCopy(expandedRow?.phoneNo, 'Phone Number')} className="ml-[4px] cursor-pointer"/></div>
                                                                    </Tooltip>
                                                                )
                                                                : (
                                                                    <BiSolidCopy color="hsl(var(--primary))" onClick={() => handleCopy(expandedRow?.phoneNo, 'Phone Number')} className="ml-[4px] cursor-pointer"/>
                                                                )

                                                        )}
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <div className="flex flex-row py-2">
                                                        <div className="text-lg text-primary font-semibold">{t('Address')}</div>
                                                        <div style={{ wordWrap: 'break-word', whiteSpace: 'normal', overflowWrap: 'break-word', maxWidth: '86%' }} className="text-base text-muted font-normal ml-8 break-words whitespace-normal">
                                                            {expandedRow?.address
                                                                ? (
                                                                    <>{`${expandedRow?.address}, ${cityName}, ${stateName}, ${countryName}, ${expandedRow?.pincode}`}</>
                                                                )
                                                                : (
                                                                    '-'
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </GrcTable>
                                </GrcTableContainer>
                            )}
                        </div>
                        {!expandedRow && paginatedData.length > 0 && <div className={cn('border-t-2 border-t-primary-foreground flex flex-row items-center justify-between static py-2 pr-[20px] w-[100%]')}>
                            <p className="text-muted text-xl">
                                {t('Showing data')} {(currentPage - 1) * rowsPerPage + 1} {t('to')} {Math.min(currentPage * rowsPerPage, filteredBoardMembers?.length)} {t('of')} {filteredBoardMembers?.length} {t('entries')}
                            </p>
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={handlePageChange}
                                color="primary"
                                shape="rounded"
                                variant="outlined"
                            />
                        </div>}
                    </Card>
                </div>
                <AddBoardDrawer
                    nodes={getAllBoardMemberDetails}
                    newNode={newNode}
                    onAdd={onAdd}
                    setnewNode={setNewNode}
                    currentNode={newNode}
                    setAddState={setAddState}
                    addState={addState}
                    childNodeCount={0}
                    loading={loading}
                    setLoading={setLoading}
                />
                <EditBoardDrawer
                    nodes={getAllBoardMemberDetails}
                    onEdit={onEdit}
                    editNode={editNode}
                    setEditNode={setEditNode}
                    currentNode={editNode}
                    setEditState={setEditState}
                    editState={editState}
                    childNodeCount={0}
                    loading={loading}
                    setLoading={setLoading}
                />
                </>
                )}
        </div>
    )
}

export default BoardMembers
